import { useState } from 'hooks'

import { constant } from './constant'
import { getSpectrumComponents } from './selector'

type State = {
	target: NodeListOf<HTMLInputElement>
}

export const Spectrum = (() => {
	const { state, setState } = useState<State>()

	const convertColor = (color: string) => {
		if (color.length === 9 && color.startsWith('#')) {
			const a = color.slice(7, 9)
			const rgb = color.slice(1, 7)

			color = `#${a}${rgb}`
		}

		return color
	}

	const initColorPicker = () => {
		const { target } = state
		if (target.length === 0) {
			return
		}

		target.forEach((element) => {
			const palette = [...constant.defaultColorPalette]

			let defaultColor = element.getAttribute(constant.defaultColor)
			if (defaultColor !== null) {
				defaultColor = convertColor(defaultColor)
				palette.push([defaultColor])
			}

			let color = element.getAttribute(constant.initColor)
			if (!color) {
				color = defaultColor ?? constant.defaultColorValue
			}

			color = convertColor(color)

			let showAlpha = false
			const isAlpha = element.getAttribute(constant.isAlpha)
			if (isAlpha && isAlpha === 'true') {
				showAlpha = true
			}

			let allowEmpty = false
			if (element.getAttribute(constant.allowEmpty) === 'true') {
				allowEmpty = true
			}

			// @ts-ignore
			$(element).spectrum({
				type: 'color',
				showInput: true,
				allowEmpty,
				showAlpha,
				preferredFormat: 'rgb',
				color,
				palette,
				locale: 'en',
			})
		})
	}

	const init = () => {
		setState({ ...getSpectrumComponents() })

		initColorPicker()
	}

	return {
		init,
	}
})()
